import styled from "@emotion/styled";
import type { FC } from "react";
import React, { useEffect, useRef } from "react";
import { appStatusBarState } from "src/state/state";

const Wrap = styled.div`
  label: AppSubPage;
  position: relative;
  padding: 0;
`;

const AppSubPage: FC<{
  children?: React.ReactNode;
}> = (props) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    appStatusBarState.subPageOpen();
    return () => {
      appStatusBarState.subPageClose();
    };
  }, []);

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "instant", block: "start" });
  }, []);

  return <Wrap ref={ref}>{props.children}</Wrap>;
};

export default AppSubPage;
